import {
    CARD_UPDATE_INFO,
    CARD_REMOVE
} from '../actions/actionTypes';

const defaultState = {
    token: "",
    paymentType: null
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case CARD_UPDATE_INFO:
            return { ...state,
                [action.key]: action.value,
                paymentType: action.paymentType
            };
        case CARD_REMOVE: {
            return { ...state, token: "" }
        }
        default:
            return state;
    }
};
